import { useState as u, useEffect as f } from "react";
import { useForwardedRef as l } from "../../../hooks/useForwardedRef.js";
const a = (e) => {
  const t = l(e), [r, c] = u(!1);
  return f(() => {
    if (t.current) {
      const s = t.current.offsetWidth, o = t.current.scrollWidth, n = t.current.scrollHeight, i = t.current.clientHeight;
      c(
        // true if using normal css / single line truncation
        s < o || i + 1 < n
        // The +1 here is used to fight a firefox bug where
        // the scroll height would change by 1 pixel between renders when
        // experiencing no text trunaction, possibly due to implementation
        // of -webkit-line-clamp or similar
      );
    }
  }), { ref: t, isTruncated: r };
};
export {
  a as useTruncated
};
